import { Col, Form, FormControl, FormGroup, Row } from "react-bootstrap";

import { useTranslateContext } from "../../contexts/translate.context";

export interface ILostAndFoundRecordProps {
    title: any,
    isEdit: boolean,
    identifier: boolean,
    viewOnly?: boolean,

    created?: any,
    updated?: any,
    setCreated?: any,
    setUpdated?: any,
    listEstate: any,

    estateId: any,
    name: any,
    description: any,
    launch: any,
    delivered: any,
    setEstateId: any,
    setName: any,
    setDescription: any,
    setLaunch: any,
    setDelivered: any,

}

export const LostAndFoundRecord: React.FC<ILostAndFoundRecordProps> = (props: ILostAndFoundRecordProps) => {

    const { display } = useTranslateContext();

    return (
        <>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-estate">{display.label.estate}</Form.Label>
                        <Form.Select id="form-estate" name="estate" 
                            value={props.estateId} 
                            onChange={(e: any) => props.setEstateId(e.target.value)}
                        >
                            { props.estateId === 0 ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listEstate.map((iterator: any, idx: number) => (<option key={idx} value={iterator.id}>{iterator.name}</option>)).sort((a : any, b : any) => { return a.props.children > b.props.children ? 1 : -1; }) }
                        </Form.Select>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-name">{display.label.name}</Form.Label>
                        <FormControl id="form-name" name="name" placeholder={display.example.name}
                            disabled={!props.isEdit}
                            value={props.name}
                            onChange={e => props.setName(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col className="ms-0 me-0 ps-0 pe-0" sm="2">
                    <Row>
                        <Col>
                            <FormGroup>
                                <Form.Label htmlFor="form-launch">{display.label.date_launch}</Form.Label>
                                <FormControl id="form-launch" name="launch" placeholder={display.example.launch}
                                    disabled={!props.isEdit}
                                    readOnly={true}
                                    value={props.launch}
                                    onChange={e => props.setLaunch(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Form.Label htmlFor="form-delivered">{display.label.date_delivered}</Form.Label>
                                <FormControl id="form-delivered" name="delivered" placeholder={display.example.delivered}
                                    disabled={!props.isEdit}
                                    value={props.delivered}
                                    onChange={e => props.setDelivered(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-description">{display.label.description}</Form.Label>
                        <FormControl as="textarea" rows={3} id="form-description" name="description" placeholder={display.example.description}
                            disabled={!props.isEdit}
                            value={props.description}
                            onChange={e => props.setDescription(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>
    );

}

export default LostAndFoundRecord;
